import { deleteApi } from "./api_instance";
export const cancelBids = async (bidId, remarks, reason, dispatch) => {

  try {
    const { data } = await deleteApi({
      apiUrl: `/projects/api/myBids/cancel-bid?bidId=${bidId}`,
      sendToken: true,
      dispatch,
      data: {
        remarks: remarks,
        reason: reason,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
